// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__sBmya","testimonials__title":"Testimonials_testimonials__title__A6YgU","testimonials__cards":"Testimonials_testimonials__cards__-STbn"};